import { CodeBook } from "@king-ict/eupisi-ui/models/Common";

import { ClaimType, UserPermission } from "../../models/User";

export const getDefaultCountyIds = ({
  currentRole,
  counties,
}: {
  currentRole?: UserPermission;
  counties?: CodeBook[];
}): number[] => {
  if (!currentRole) return [];

  // Used for Founder role to return the counties that are in his institution (location) list
  if (counties) {
    return counties.map((county) => county.id);
  }

  const hasCountyClaimWithLocations =
    currentRole?.claimType === ClaimType.County && !!currentRole?.locations;

  return hasCountyClaimWithLocations && currentRole?.locations
    ? currentRole.locations
    : ([] as number[]);
};
